<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>商城</el-breadcrumb-item>
      <el-breadcrumb-item>订单列表</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="panel mt-20">
      <div class="filter">
        <el-form
          :model="filter"
          ref="filterForm"
          label-position="left"
          label-width="70px"
        >
          <el-form-item label="订单号" prop="number">
            <el-input
              size="small"
              v-model="filter.number"
              @keyup.enter.native="requestSearch"
              autocomplete="off"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="中间商"
            prop="dealer_id"
            v-if="userInfo.dealer_id == 0"
          >
            <dealer-select
              style="width: 100%"
              :val="filter.dealer_id"
              @change="filter.dealer_id = $event"
            ></dealer-select>
          </el-form-item>

          <el-form-item label="最终客户" prop="customer_id">
            <customer-select
              style="width: 100%"
              :val="filter.customer_id"
              @change="filter.customer_id = $event"
            ></customer-select>
          </el-form-item>

          <el-form-item label="件号" prop="part_number">
            <el-input
              size="small"
              v-model="filter.part_number"
              @keyup.enter.native="requestSearch"
              autocomplete="off"
            ></el-input>
          </el-form-item>

          <!-- <el-form-item label="状态" prop="status">
            <el-select v-model="filter.status" clearable size="small">
              <el-option
                v-for="(item, index) in CommodityOrderStatusMap"
                :label="item.name"
                :key="index"
                :value="index"
              ></el-option>
            </el-select>
          </el-form-item> -->

          <el-form-item label="下单日期" prop="date">
            <el-date-picker
              v-model="filter.date"
              type="daterange"
              size="small"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-form>
        <div class="mt-10">
          <el-button type="primary" size="small" @click="requestSearch"
            >筛选</el-button
          >
          <el-button size="small" @click="requestSearch('reset')"
            >重置</el-button
          >
        </div>
      </div>
    </div>

    <div class="panel mt-20">
      <el-table
        v-if="!isMobile()"
        :data="list"
        stripe
        style="width: 100%"
        v-loading="loading"
        :key="$route.meta.name"
      >
        <!-- <el-table-column
          align="center"
          prop="number"
          label="订单号"
        ></el-table-column> -->
        <el-table-column align="left" label="订单详情" min-width="200px">
          <template slot-scope="scope">
            <div>订单号：{{ scope.row.number }}</div>
            <div class="item-container" v-for="item in scope.row.items">
              <div class="flex-row">
                <auth-img
                  tag="el-image"
                  :src="item.cover"
                  style="width: 60px; height: 60px"
                  fit="cover"
                ></auth-img>
                <div class="item-info">
                  <!-- <span>{{ item.name }}</span> -->
                  <span class="part-number">{{ item.part_number }}</span>
                  <span>
                    <el-tag size="mini">{{
                      item.commodity_category_name
                    }}</el-tag>
                  </span>
                  <span class="item-desc">{{ item.description }}</span>
                </div>
              </div>

              <div>x {{ item.number }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="中间商"
          prop="dealer.name"
          v-if="userInfo.dealer_id == 0"
        >
        </el-table-column>
        <el-table-column align="center" label="最终客户" prop="customer.name">
        </el-table-column>
        <el-table-column align="center" label="金额">
          <template slot-scope="scope">
            ￥{{ scope.row.total_price.toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="下单时间" width="160px">
          <template slot-scope="scope">
            {{
              $time(new Date(scope.row.created_at)).format('YYYY-MM-DD HH:mm')
            }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="状态">
          <template slot-scope="scope">
            <status-tag
              :name="CommodityOrderStatusMap[scope.row.status].name"
              :type="CommodityOrderStatusMap[scope.row.status].type"
            >
            </status-tag>
            <br />

            <!-- <div>{{ CommodityOrderStatusMap[scope.row.status].name }}</div> -->
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="200">
          <template slot-scope="scope">
            <el-popconfirm
              v-if="scope.row.status == 2 || scope.row.status == 5"
              v-permission="Auth.commodityOrderCancel"
              :title="`确认取消吗？`"
              @confirm="handleCancel(scope.row, scope.$index)"
            >
              <el-button slot="reference" type="danger" plain size="mini"
                >取消</el-button
              >
            </el-popconfirm>
            <el-popconfirm
              v-permission="Auth.commodityOrderDelete"
              :title="`确认删除吗？`"
              v-if="scope.row.status == 1 || scope.row.status == 3"
              @confirm="handleDelete(scope.row, scope.$index)"
            >
              <el-button slot="reference" type="danger" plain size="mini"
                >删除</el-button
              >
            </el-popconfirm>

            <el-button
              class="ml-10"
              type="primary"
              plain
              size="mini"
              v-permission="Auth.commodityOrderManage"
              v-if="scope.row.status == 5"
              @click="handlePay(scope.$index, scope.row)"
              >支付</el-button
            >
            <el-button
              class="ml-10"
              type="primary"
              plain
              size="mini"
              v-permission="Auth.commodityOrderApprove"
              v-if="scope.row.status == 2"
              @click="handleApprove(scope.row, scope.$index)"
              >审批</el-button
            >

            <el-popconfirm
              v-if="scope.row.status == 6"
              v-permission="Auth.commodityOrderFinish"
              :title="`确认完成吗？`"
              @confirm="handleFinish(scope.row, scope.$index)"
            >
              <el-button slot="reference" type="primary" plain size="mini"
                >完成</el-button
              >
            </el-popconfirm>

            <router-link
              :to="`${$route.path}/${scope.row.id}`"
              v-permission="Auth.commodityOrderDetail"
              ><el-button class="ml-10" type="primary" plain size="mini"
                >详情</el-button
              ></router-link
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20"
        :page-size="filter.size"
        @current-change="handlePageChange"
        :current-page.sync="filter.page"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>

    <pay-former
      :model="model"
      :show.sync="payFormVisible"
      @updated="updatedCallback"
    ></pay-former>
  </div>
</template>

<script>
import {
  commodityOrderList,
  deleteCommodityOrder,
  updateCommodityOrderStatus,
  commodityOrderFinish,
  commodityOrderApprove,
} from '@/service/getData'
import { isMobile } from '../../../util'
import { clone } from '@/util'
import { CommodityOrderStatusMap } from '@/config/global'
import PayFormer from './pay_former'
import store from '@/store/store'
import DealerSelect from '@/components/select/dealer_select'
import CustomerSelect from '@/components/select/customer_select'

export default {
  components: {
    PayFormer,
    DealerSelect,
    CustomerSelect,
  },
  data() {
    return {
      userInfo: store.getters.userInfo,
      editIndex: 0,
      model: {},
      payFormVisible: false,
      CommodityOrderStatusMap,
      isMobile,
      list: [],
      loading: false,
      total: 0,
      filter: {
        size: 20,
        page: 1,
        status: '',
        part_number: '',
        customer_id: '',
        dealer_id: '',
      },
    }
  },
  watch: {
    $route: function () {
      this.requestSearch('reset')
    },
  },
  created() {
    this.getData()
  },
  methods: {
    requestSearch(reset = '') {
      this.filter.page = 1
      if (reset == 'reset') {
        this.filter.number = ''
        this.filter.part_number = ''
        this.filter.date = ''
        this.filter.customer_id = ''
        this.filter.dealer_id = ''
      }
      this.getData()
    },

    async getData() {
      this.loading = true
      let params = clone(this.filter)
      params.page -= 1

      if (params.date && params.date.length == 2) {
        params.start_date = params.date[0]
        params.end_date = params.date[1]
      }

      params.status = this.$route.meta.status || -1
      let res = await commodityOrderList(params)
      if (res.code == 0) {
        this.list = res.data.list
        this.total = res.data.total
        this.loading = false
      }
    },
    handlePageChange(e) {
      this.filter.page = e
      this.getData()
    },

    handlePay(index, item) {
      this.editIndex = index
      this.model = {
        id: item.id,
        payed_proof: '',
        payed_remark: '',
      }
      this.payFormVisible = true
    },
    async handleCancel(item, index) {
      let res = await updateCommodityOrderStatus({ id: item.id })
      if (res.code == 0) {
        this.$set(this.list, index, res.data)
      }
    },
    updatedCallback(data) {
      this.$set(this.list, this.editIndex, data)
    },
    async handleFinish(item, index) {
      let res = await commodityOrderFinish({ id: item.id })
      if (res.code == 0) {
        this.$set(this.list, index, res.data)
      }
    },
    handleApprove(item, index) {
      let data = { id: item.id, agree: true }

      this.$prompt('备注（驳回选填）', '订单审批', {
        distinguishCancelAndClose: true,
        confirmButtonText: '驳回',
        cancelButtonText: '通过',
        inputPlaceholder: '驳回选填',
        cancelButtonClass: 'btn-cacel',
        confirmButtonClass: 'btn-confirm',
      })
        .then(async ({ value }) => {
          data.agree = false
          data.reject_reason = value
          let res = await commodityOrderApprove(data)
          this.$set(this.list, index, res.data)
        })
        .catch(async (action) => {
          if (action == 'cancel') {
            let res = await commodityOrderApprove(data)
            this.$set(this.list, index, res.data)
          }
        })
    },
    async handleDelete(item, index) {
      let res = await deleteCommodityOrder(item.id)
      if (res.code == 0) {
        this.list.splice(index, 1)
      }
    },
  },
}
</script>
<style scoped>
.item-container {
  padding: 4px 0px;
  display: flex;
  align-content: flex-start;
  justify-content: space-between;
}
.item-info {
  display: flex;
  flex-direction: column;
  margin-left: 10px;
}
.item-desc {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  height: 40px;
  color: #666;
}
.part-number {
  color: #3d3d3d;
  font-size: 16px;
  font-weight: 500;
}
</style>
<style >
.btn-confirm,
.btn-confirm:hover {
  background: #292b2c !important;
  border: 1px solid #292b2c !important;
}
.btn-cacel,
.btn-cacel:hover {
  background-color: #047bf8 !important;
  border-color: #047bf8 !important;
}
</style>